import { Model, attr } from '@elatonsev/js-models';

export default class PointSettingsModel extends Model {
  online_booking_prepayment = attr('string', {defaultValue: 'no'});
}